var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper-container"},[_c('div',{staticClass:"stepper"},_vm._l((_vm.totalSteps),function(step){return _c('div',{key:step,staticClass:"step-wrapper",class:{ 'last-step': step === _vm.totalSteps }},[_c('div',{staticClass:"step-circle",class:{
          'completed': step <= _vm.currentStep,
          'inactive': step > _vm.currentStep
        }},[_vm._v(" "+_vm._s(step)+" ")]),(step < _vm.totalSteps)?_c('div',{staticClass:"step-line",class:{
          'completed': step < _vm.currentStep,
          'inactive': step >= _vm.currentStep
        }}):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }